import { PeoStaffRole } from 'src/api';
import { SelectFieldOption } from 'src/types/components';

export const PEO_STAFF_ROLE_LABEL_MAP: Record<PeoStaffRole, string> = {
  [PeoStaffRole.PeoSuperAdmin]: 'Super Admin',
  [PeoStaffRole.PeoAdmin]: 'Admin',
  [PeoStaffRole.PeoManager]: 'Manager',
} as const;

export const PEO_ROLE_OPTIONS = [
  {
    value: PeoStaffRole.PeoSuperAdmin,
    label: PEO_STAFF_ROLE_LABEL_MAP[PeoStaffRole.PeoSuperAdmin],
  },
  {
    value: PeoStaffRole.PeoAdmin,
    label: PEO_STAFF_ROLE_LABEL_MAP[PeoStaffRole.PeoAdmin],
  },
  {
    value: PeoStaffRole.PeoManager,
    label: PEO_STAFF_ROLE_LABEL_MAP[PeoStaffRole.PeoManager],
  },
] as const satisfies SelectFieldOption<PeoStaffRole>[];
